import { GET_CHARTS, ANOBIS_MINIMAL_MODE, RunningAnobisMode } from "src/shared/config";
import { ApiResponse } from "src/shared/types";
import appFetch from "src/shared/fetch";
import { getServiceName } from "src/utils/getservicename";

interface IGetChartsParam {
  data: any;
  timeTab: string;
  shouldFetchFreshData?: boolean;
}

export const getCharts = ({ data, timeTab, shouldFetchFreshData }: IGetChartsParam): ApiResponse => {
  const headers = {
    "Content-Type": "application/json",
  };
  if (shouldFetchFreshData) headers["X-Clear-Cache"] = "true";
  headers["X-Client-Id"] = getServiceName();
  return appFetch.post(GET_CHARTS, {
    params: { timeTab },
    body: data,
    headers,
    config: { credentials: "include" },
  });
};

export const fetchAnobisMinimalModeInfo = async (): Promise<ApiResponse> =>
  await appFetch.get(ANOBIS_MINIMAL_MODE, {}).then((response) => response);

let MinimalModeContent = {};
let VisibleAnobisTabs: any = [...RunningAnobisMode.SHOW_ALL_TABS];
export const fetchData = async () => {
  try {
    const anobisMinimalMode = await fetchAnobisMinimalModeInfo().then((res) => {
      return {
        message: res["response"].message,
        enabled: res["response"].flag,
      };
    });
    if (anobisMinimalMode.enabled) {
      MinimalModeContent = anobisMinimalMode;
      VisibleAnobisTabs.length = 0;
      VisibleAnobisTabs.push(...RunningAnobisMode.SHOW_ONLY_THIS_WEEK_TABS);
    }
  } catch (error) {
    // ignore
  }
};
// disable minimal mode fetch for now
// fetchData();

export const TabNames = VisibleAnobisTabs;
export { MinimalModeContent };
